module.exports = __webpack_public_path__ + "img/Dantam Hair 51.11ef8a63.jpg";